import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface EtfNotFoundProps {
  slug: string;
  entityName: string;
  entityDescription?: string;
  backLabel: ReactNode;
  backHref: string;
  backClassName?: string;
}

export function EtfNotFound({
  slug,
  entityName,
  entityDescription,
  backLabel,
  backHref,
  backClassName = "font-[family-name:var(--font-instrument)] text-sm text-[var(--etf-orange)] no-underline tracking-[0.06em] inline-flex items-center gap-1.5 transition-[gap] duration-200 hover:gap-2.5",
}: EtfNotFoundProps) {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <div className="text-6xl font-light text-[var(--etf-white3)] mb-4">404</div>
        <h1 className="text-2xl font-light text-[var(--etf-white)] mb-2">{entityName} Not Found</h1>
        <p className="text-sm text-[var(--etf-white3)] mb-6">
          No {(entityDescription ?? entityName).toLowerCase()} exists with the slug &ldquo;{slug}
          &rdquo;.
        </p>
        <Link to={backHref} className={backClassName}>
          {backLabel}
        </Link>
      </div>
    </div>
  );
}
